import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ability from '@/libs/acl/ability'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInit: false,
        user: null,
        stores: null,

        orderStatus: [
            { text: "Ikke modtaget", value: 0 },
            { text: "Ordre modtaget", value: 1 },
            { text: "Under behandling", value: 2 },
            { text: "Afsendt", value: 3 },
            { text: "Genåbnet", value: 4 },
            { text: "Annulleret", value: 5 },
            { text: "Klar til afhentning", value: 6 },
            { text: "Delvist afsendt", value: 7 },
            { text: "Afhentet", value: 8 },
            { text: "Kladde", value: 99 },
            { text: "Kreditnota", value: 100 },
        ],

    },

    actions: {
        INIT_USER({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                axios.get("/api/user").then(x => {
                    commit("INIT_USER", x.data)
                    ability.update(x.data.acl)
                    resolve()
                }).catch(x => {
                    commit("INIT_USER", null)
                    resolve()
                })
            })
        },
        LOGIN({ commit, dispatch }, data) {
            commit("INIT_USER", data)
        },
        STORES({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                axios.get("/api/stores").then(x => {
                    commit("STORES", x.data)
                    resolve()
                })
            })
        },
    },

    mutations: {
        INIT_USER(state, val) {
            state.userInit = true
            state.user = val
        },
        STORES(state, val) {
            state.stores = val
        }
    },


    modules: {
        app,
        appConfig,
        verticalMenu,
    },
    strict: process.env.DEV,
})
